var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-price-row',{staticClass:"paid-member-price",attrs:{"label":"メンバー","price-with-tax":_vm.priceWithTax}})}
var staticRenderFns = []

export { render, staticRenderFns }